<div class="layout-column full-height provider-type-multi-select-list">
  <div class="layout-row padding-10">
    <bz-search-input class="flex"
                     appBringozIdGenerator="filterSearchInput"
                     [placeholder]="(placeholder() || 'Search') | translate"
                     [debounceMs]="1000"
                     (valueChange)="query.set($event)">
    </bz-search-input>
  </div>

  <div class="flex layout-column overflow-auto">
    @for (row of rows(); track row.option) {
      <div class="provider-type-option layout-row layout-align-start-center">
        <bz-checkbox class="flex"
                     appBringozIdGenerator="providerTypeOption"
                     ariaLabel="Select Item"
                     [checked]="row.checked"
                     (checkedChange)="onToggle(row.option, $event)">
          <span class="text-ellipsis">{{ 'TPL_PROVIDER_TYPE.' + row.option | translate }}</span>
        </bz-checkbox>
      </div>
    }
  </div>
</div>
